import React from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faEnvelopeOpenText } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

// Import Swiper core styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "./ActivityLevelCard.css";

export default function ActivityLevelCard({ level = "medium" }) {
  const isHigh = level.toLowerCase() === "medium";

  return (
    <Card className="score-card activity-card ">
      <Card.Body className="score-card__body ">
        
        {/* Semi-Circle Progress Gauge */}
        <div className="gauge-container">
          <div className={`gauge-arc-track gauge-arc-track--${level}`}></div>
          <div className="gauge-center-content">
            <h3 className={`gauge-title-text gauge-title-text--${level}`}>
              {isHigh ? "High" : "Medium"}
            </h3>
            <span className="gauge-subtitle-text">Activity level</span>
          </div>
        </div>

        <p className="activity-card-description">
          High activity level gets you more attention from recruiters
        </p>
        
        <hr className="divider-line" />
        
        {/* Swiper Implementation Section */}
        <div className="tips-section">
          <h6 className="tips-header-title">Tips to improve your activity level</h6>
          
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            initialSlide={isHigh ? 1 : 0}
            autoplay={{
              delay: 3000, // Slides change every 3 seconds
              disableOnInteraction: false, // Keeps autoplay running even after user swipes
            }}
            pagination={{ 
              clickable: true,
              el: '.custom-carousel-dots',
              bulletClass: 'indicator-dot',
              bulletActiveClass: 'indicator-dot--active'
            }}
            className="tips-swiper-slider"
          >
            {/* Slide 1: Medium Activity Tip */}
            <SwiperSlide>
              <div className="tip-item-wrapper">
                <div className="tip-icon-container">
                  <FontAwesomeIcon icon={faBriefcase} />
                </div>
                <div className="tip-text-block">
                  <p className="tip-action-heading">Apply to relevant jobs</p>
                  <span className="tip-action-subtext">
                    Regular job applications increase your visibility
                  </span>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 2: High Activity Tip */}
            <SwiperSlide>
              <div className="tip-item-wrapper">
                <div className="tip-icon-container">
                  <FontAwesomeIcon icon={faEnvelopeOpenText} />
                </div>
                <div className="tip-text-block">
                  <p className="tip-action-heading">Open recruiter outreach email</p>
                  <span className="tip-action-subtext">
                    Open at least one recruiter outreach email to boost activity
                  </span>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        {/* Dynamic target container for Swiper Pagination modules */}
        <div className="custom-carousel-dots"></div>

      </Card.Body>
    </Card>
  );
}